var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Layout',{attrs:{"layout":"center"}},[_c('div',{staticClass:"content"},[_c('h1',[_vm._v("Retro Tasks")]),(_vm.taskIds && _vm.taskIds.length)?_c('retro-outcomes',{attrs:{"tasks":_vm.tasks,"taskIds":_vm.taskIds}}):_vm._e()],1)])}
var staticRenderFns = []

export { render, staticRenderFns }